import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import MInput from "../../Components/Input";
import Overlay from "../../Components/Overlay";
import MTextarea from "../../Components/TextArea";
import moment from "moment";
import {
  getCountryAll,
  getProvince,
  getSeries,
  getDebitorAccount,
  getPPN,
  getOrderType,
  getSOHeader,
  getCustomer,
  updateDelivery,
  updateSODetail,
  updateSO,
  getSeriesCustomer,
  getBank,
} from "../../Service/SalesService";
import MSelect from "../../Components/MSelect";
import Swal from "sweetalert2";
import { NumberFormat } from "../../Components/NumberFormat";
import { print } from "../../Images";
import PrintSO from "./PrintSO";
import { useReactToPrint } from "react-to-print";
import { ParseDecimal } from "../../Components/CurrencyInput/ParseDecimal";

let processingId = -1;
const { $ } = window;
const ApprovalSOForm = () => {
  const componentRef = useRef();
  const navigate = useNavigate();
  const { id_so } = useParams();
  const RejectComment = useRef();
  let { userInfo } = useSelector((state) => state.auth);
  const options = [{ value: "ID", label: "Indonesia" }];

  const [info, setInfo] = useState({
    legal: "",
    deduction_remark: "",
    nama_customer: "",
    kode_customer: "",
    phone: "",
    email: "",
    address: "",
    delivery_date: moment().format("YYYY-MM-DD"),
    created_date: moment().format("YYYY-MM-DD"),
    detail: [],
    listppn: [],
    country: [],
    province: [],
    bank: [],
    province_label: "",
    city: [],
    ordertype: [],
    city_label: "",
    series: "",
    series_cust: "",
    total: 0,
    total_ppn: 0,
    total_pph: 0,
    total_dpp: 0,
    diskon_promo: 0,
    grand_total: 0,
    total_discount: 0,
    deduction: 0,
    pph_rate: 0,
    WTCode: "",
    WTName: "",
    status_so: "",
  });
  const [state, setState] = useState({
    processing: false,
    loading: false,
    refresh: false,
    locked: false,
    county: "ID",
    province: "",
    city: "",
    order_type: "FGS",
    ShipToCode: "",
    showProduct: false,
    order_id: null,
    order_no: "",
    listPromo: [],
    listPayment: [],
    listPromoSelected: "",
    total_payment: 0,
    showbtnpayment: false,
    approved_date: null,
    note_approval: null,
    opsiProduct: {
      itemname: "",
      itemno: "",
      price: 0,
      qty: 1,
      type: "D",
      paketid: "",
      gudang: "",
    },
    customer: {
      cardid: "",
      CardName: "",
      CardType: "C",
      Phone1: "",
      MailAddres: "",
      Address: "",
      form_country: "",
      form_city: "",
      form_province: "",
      WTCode: "",
      Series: "",
      DebPayAcct: "",
      DpmClear: "",
      ECVatGroup: "",
      validFor: "Y",
      branch: userInfo.BPLId,
      GroupCode: "12",
    },
  });

  const { detail, deduction, listppn, total_discount, bank } = info;
  const { refresh } = state;

  useEffect((_) => {
    initPage();
  }, []);

  useEffect(
    (_) => {
      if (refresh) {
        initPage();
      }
    },
    [refresh]
  );

  const initPage = () => {
    const request = [
      getCountryAll({ perpage: 100 }).then((res) => res.data.data),
      getSeries({
        filter: `"ObjectCode":17,"Remark":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getSeriesCustomer({
        filter: `"ObjectCode":2,"DocSubType":C,"Remark":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getDebitorAccount({
        filter: `"Segment_0":1102010,"Segment_2":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getDebitorAccount({
        filter: `"Segment_0":2102010,"Segment_2":${userInfo.BPLName}`,
      }).then((res) => res.data.data),
      getPPN({
        filter: `"Segment_0":2101550,"Segment_2":${userInfo.BPLName}`,
        add_fields: ['"Segment_0"', '"Segment_2"'],
      }).then((res) => res.data.data),
      getOrderType({ perpage: 100 }).then((res) => res.data.data),
      getBank({ perpage: 100 }).then((res) => res.data.data),
    ];

    request.push(getSOHeader(id_so).then((res) => res.data));
    Promise.all(request).then((results) => {
      const [
        _country,
        _series,
        _seriesCust,
        _debacc,
        _dpclear,
        _ppn,
        _ordertype,
        _bank,
        _so,
      ] = results;
      let _newCountry = _country.map((item) => {
        return {
          label: item.Name,
          value: item.Code,
        };
      });

      let _newOrderType = _ordertype.map((item) => {
        return {
          label: item.Name,
          value: item.Code,
        };
      });

      let _new_bank = _bank.map((item) => {
        return {
          label: item.BankCode,
          value: item.BankCode,
          rekening: item.Account,
        };
      });

      let total = 0;
      let total_disk = 0;
      let sum_dpp = 0;
      for (const key in _so.detailItem) {
        let _subtotal =
          _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;
        total += _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;
        let _net_disc = _so.detailItem[key].M_DISC_1
          ? parseFloat(_so.detailItem[key].M_DISC_1) / 100
          : 0;
        let _net_disc_amt = _subtotal - _subtotal * _net_disc;
        let _campaign_disc =
          _subtotal > 0
            ? parseFloat(_so.detailItem[key].M_DISC_2) / _subtotal
            : 0;
        // let _prcntdisc = _net_disc + ((1-_net_disc) * _campaign_disc);

        let _disk2 = _so.detailItem[key].M_DISC_2_PRC
          ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100
          : 0;
        let _disk3 = _so.detailItem[key].M_DISC_3
          ? parseFloat(_so.detailItem[key].M_DISC_3) / 100
          : 0;
        let _disk4 = _so.detailItem[key].M_DISC_4
          ? parseFloat(_so.detailItem[key].M_DISC_4) / 100
          : 0;
        let _delta_disc =
          (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
        _delta_disc = _delta_disc.toFixed(4);
        let _prcntdisc = 1 - _delta_disc;
        _prcntdisc = _prcntdisc.toFixed(4);
        let _dpp = parseFloat(
          _so.detailItem[key].VatPrcnt == 0
            ? _subtotal - _prcntdisc * _subtotal
            : (_subtotal - _prcntdisc * _subtotal) /
            (1 + _so.detailItem[key].VatPrcnt / 100)
        );

        sum_dpp += _dpp;
        total_disk += _prcntdisc * _subtotal;
      }

      let total_payment = 0;
      for (const key in _so.payment) {
        total_payment += parseFloat(_so.payment[key].Amount);
      }

      let arr_detail = [];
      for (const key in _so.detailItem) {
        let deduct = parseFloat(_so.DiscSum || 0);
        let subtotal = _so.detailItem[key].TotalBefDi * _so.detailItem[key].Qty;
        let pph_selected = _so.detailItem[key].WtLiable == "1" ? "Y" : "N";
        let disc_deduction = parseFloat(((deduct + total_disk) / total) * 100);
        let net_disc = _so.detailItem[key].M_DISC_1
          ? parseFloat(_so.detailItem[key].M_DISC_1) / 100
          : 0;
        let net_disc_amt = subtotal - subtotal * net_disc;

        let disk2 = _so.detailItem[key].M_DISC_2_PRC
          ? parseFloat(_so.detailItem[key].M_DISC_2_PRC) / 100
          : 0;
        let disk3 = _so.detailItem[key].M_DISC_3
          ? parseFloat(_so.detailItem[key].M_DISC_3) / 100
          : 0;
        let disk4 = _so.detailItem[key].M_DISC_4
          ? parseFloat(_so.detailItem[key].M_DISC_4) / 100
          : 0;
        let delta_disc =
          (1 - net_disc) * (1 - disk2) * (1 - disk3) * (1 - disk4);
        delta_disc = delta_disc.toFixed(4);
        let prcntdisc = 1 - delta_disc;
        prcntdisc = prcntdisc.toFixed(4);
        let disc_total = subtotal * (parseFloat(prcntdisc) / 100);
        let dpp = parseFloat(
          _so.detailItem[key].VatPrcnt == 0
            ? 0
            : (subtotal - prcntdisc * subtotal) /
            (1 + _so.detailItem[key].VatPrcnt / 100)
        );
        let prcnt_bef = (deduct / sum_dpp) * 100;
        let am_ppn = parseFloat(
          dpp * (_so.detailItem[key].VatPrcnt / 100)
        ).toFixed(2);
        let am_ppn_after_disc = am_ppn - am_ppn * (prcnt_bef / 100);
        let am_pph = dpp - (dpp * prcnt_bef) / 100;

        arr_detail.push({
          itemname: _so.detailItem[key].Dscription,
          itemno: _so.detailItem[key].ItemCode,
          price: _so.detailItem[key].TotalBefDi,
          qty: _so.detailItem[key].Qty,
          type: _so.detailItem[key].TypeWhs,
          paketid: _so.detailItem[key].M_KD_CMPG,
          paket_name: _so.detailItem[key].M_KET_CMPG,
          gudang: _so.detailItem[key].WHS,
          free: _so.detailItem[key].TotalBefDi <= 0 ? 1 : 0,
          id: _so.detailItem[key].id,
          ppn: _so.detailItem[key].VatPrcnt,
          delivery: _so.detailItem[key].Delivery,
          pph: _so.detailItem[key].WtLiable,
          total_bef_di: _so.detailItem[key].TotalBefDi,
          M_DISC_1: _so.detailItem[key].M_DISC_1,
          M_DISC_2_PRC: _so.detailItem[key].M_DISC_2_PRC,
          amount_ppn: am_ppn_after_disc,
          amount_pph: pph_selected == "y" ? am_pph * (info.pph_rate / 100) : 0,
          amount_dpp: dpp,
          amount_discount: prcntdisc * subtotal,
          net_disc: parseFloat(_so.detailItem[key].M_DISC_1),
          net_disc_amt,
          disc_2: parseFloat(_so.detailItem[key].M_DISC_2),
          disc_deduction: disc_deduction,
          disc_total: disc_total,
          disc_prcnt: _so.detailItem[key].DiscPrcnt,
        });
      }

      const reqMore = [
        getCustomer({ filter: `CardCode:${_so.CardCode}` }).then(
          (res) => res.data.data
        ),
      ];
      Promise.all(reqMore).then((results) => {
        const [_customer] = results;
        if (_customer.length > 0) {
          getProvince(_customer[0].county_code).then((res) => {
            const _prov = res.data.data.map((item) => {
              return {
                label: item.U_SOL_CITY_NAME,
                value: item.U_SOL_CITY_CODE,
              };
            });
            const hitungan = Calculate(arr_detail);
            const deduksi = _so.DiscSum;
            setInfo({
              ...info,
              legal: _so.legal_stuff,
              listppn: _ppn,
              bank: _new_bank,
              country: _newCountry,
              series: _series.length > 0 ? _series[0].Series : "",
              series_cust: _seriesCust.length > 0 ? _seriesCust[0].Series : "",
              ordertype: _newOrderType,
              detail: arr_detail,
              created_date: _so.created_date,
              kode_customer: _so.CardCode,
              nama_customer: _so.CardName,
              phone: _customer[0].Phone1,
              email: _customer[0].EmailAddress,
              address: _customer[0].Address,
              province: _prov,
              status_so: _so.Status,
              delivery_date: moment(_so.DocDueDate).format("YYYY-MM-DD"),
              deduction: parseFloat(deduksi || 0),
              pph_rate: parseFloat(_so.Rate || 0),
              total_before_discount_with_free: hitungan.subtotal,
              total: hitungan.subtotal,
              total_ppn: hitungan.amount_ppn,
              total_pph: hitungan.amount_pph,
              total_dpp: hitungan.amount_dpp,
              total_discount: hitungan.amount_disc,
              grand_total:
                hitungan.amount_dpp +
                hitungan.amount_ppn -
                parseFloat(deduksi || 0) -
                hitungan.amount_pph,
            });

            const _items = _so.payment.map((e) => ({
              index: e.id,
              bank: e.BANK,
              payment_type: e.TypePayment,
              nominal_payment: parseFloat(e.Amount),
              img_upload: e.image_name,
              isSave: true,
              File: null,
            }));

            setState({
              ...state,
              order_id: id_so,
              order_no: _so.DocNumSO,
              approved_date: _so.approved_date,
              note_approval: _so.descstatus,
              province: _customer[0].county_code,
              city: _customer[0].city_code,
              ShipToCode: _customer[0].address_code,
              locked: _so.DocNumSO.substring(0, 3) == "TMP" ? false : true,
              listPayment: _items,
              total_payment: total_payment,
              refresh: false,
            });
          });
        } else {
          setInfo({
            ...info,
            country: _newCountry,
            series: _series.length > 0 ? _series[0].Series : "",
            ordertype: _newOrderType,
            detail: arr_detail,
            kode_customer: _so.CardCode,
            nama_customer: _so.CardName,
          });

          setState({
            ...state,
            refresh: false,
            order_id: id_so,
            locked: id_so.substring(0, 3) == "TMP" ? false : true,
          });
        }
      });
    });
  };

  useEffect(() => {
    if (state.order_id) {
      let arr_detail = [];
      getSOHeader(state.order_id).then((res) => {
        if (res.status == 200) {
          let items = res.data.detailItem;
          let total = 0;
          let total_disk = 0;
          let sum_dpp = 0;
          for (const key in items) {
            let _subtotal = items[key].TotalBefDi * items[key].Qty;
            total += items[key].TotalBefDi * items[key].Qty;
            let _net_disc = items[key].M_DISC_1
              ? parseFloat(items[key].M_DISC_1) / 100
              : 0;
            // let _campaign_disc = _subtotal > 0 ? parseFloat(items[key].M_DISC_2)/ _subtotal : 0;
            let _disk2 = items[key].M_DISC_2_PRC
              ? parseFloat(items[key].M_DISC_2_PRC) / 100
              : 0;
            let _disk3 = items[key].M_DISC_3
              ? parseFloat(items[key].M_DISC_3) / 100
              : 0;
            let _disk4 = items[key].M_DISC_4
              ? parseFloat(items[key].M_DISC_4) / 100
              : 0;
            let _prcntdisc =
              1 - (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
            let _delta_disc =
              (1 - _net_disc) * (1 - _disk2) * (1 - _disk3) * (1 - _disk4);
            _delta_disc = _delta_disc.toFixed(4);
            _prcntdisc = 1 - _delta_disc;
            _prcntdisc = _prcntdisc.toFixed(4);
            let _dpp = parseFloat(
              items[key].VatPrcnt == 0
                ? _subtotal - _prcntdisc * _subtotal
                : (_subtotal - _prcntdisc * _subtotal) /
                (1 + items[key].VatPrcnt / 100)
            );

            sum_dpp += _dpp;
            total_disk += _prcntdisc * _subtotal;
          }

          for (const key in items) {
            let subtotal = items[key].TotalBefDi * items[key].Qty;
            let pph_selected = items[key].WtLiable;
            let disc_deduction = parseFloat(
              ((deduction + total_disk) / total) * 100
            );
            // let disc_total = subtotal * (parseFloat(disc_deduction)/100);
            // let dpp = parseFloat(items[key].VatPrcnt == 0 ? 0 : (subtotal-disc_total)/(1+ items[key].VatPrcnt/100)).toFixed(3);
            // let am_ppn = parseFloat(dpp*(items[key].VatPrcnt/100)).toFixed(2);
            let net_disc = items[key].M_DISC_1
              ? parseFloat(items[key].M_DISC_1) / 100
              : 0;
            let net_disc_amt = subtotal - subtotal * net_disc;
            // let campaign_disc = subtotal > 0 ? parseFloat(items[key].M_DISC_2)/ subtotal : 0;
            let disk2 = items[key].M_DISC_2_PRC
              ? parseFloat(items[key].M_DISC_2_PRC) / 100
              : 0;
            let disk3 = items[key].M_DISC_3
              ? parseFloat(items[key].M_DISC_3) / 100
              : 0;
            let disk4 = items[key].M_DISC_4
              ? parseFloat(items[key].M_DISC_4) / 100
              : 0;
            let delta_disc =
              (1 - net_disc) * (1 - disk2) * (1 - disk3) * (1 - disk4);
            delta_disc = delta_disc.toFixed(4);
            let prcntdisc = 1 - delta_disc;
            prcntdisc = prcntdisc.toFixed(4);
            let disc_total = subtotal * (parseFloat(prcntdisc) / 100);
            let dpp = parseFloat(
              items[key].VatPrcnt == 0
                ? subtotal - prcntdisc * subtotal
                : (subtotal - prcntdisc * subtotal) /
                (1 + items[key].VatPrcnt / 100)
            );
            let prcnt_bef = (deduction / sum_dpp) * 100;
            let am_ppn = parseFloat(dpp * (items[key].VatPrcnt / 100)).toFixed(
              2
            );
            let am_ppn_after_disc = am_ppn - am_ppn * (prcnt_bef / 100);

            let am_pph = dpp - (dpp * prcnt_bef) / 100;

            arr_detail.push({
              itemname: items[key].Dscription,
              itemno: items[key].ItemCode,
              price: items[key].TotalBefDi,
              qty: items[key].Qty,
              type: items[key].TypeWhs,
              paketid: items[key].M_KD_CMPG,
              paket_name: items[key].M_KET_CMPG,
              gudang: items[key].WHS,
              free: items[key].TotalBefDi <= 0 ? 1 : 0,
              id: items[key].id,
              ppn: items[key].VatPrcnt,
              M_DISC_1: items[key].M_DISC_1,
              M_DISC_2_PRC: items[key].M_DISC_2_PRC,
              total_bef_di: items[key].TotalBefDi,
              delivery: items[key].Delivery,
              pph: pph_selected,
              disc_prcnt: items[key].DiscPrcnt,
              amount_ppn: am_ppn_after_disc,
              amount_pph:
                pph_selected == "y" ? am_pph * (info.pph_rate / 100) : 0,
              amount_dpp: dpp,
              amount_discount: prcntdisc * subtotal,
              net_disc: parseFloat(items[key].M_DISC_1),
              net_disc_amt,
              disc_2: parseFloat(items[key].M_DISC_2),
              disc_deduction: disc_deduction,
              disc_total: disc_total,
            });
          }

          const hitungan = Calculate(arr_detail);
          const deduksi = res.data.DiscSum;
          setInfo({
            ...info,
            detail: arr_detail,
            total: hitungan.subtotal,
            total_ppn: hitungan.amount_ppn,
            total_pph: hitungan.amount_pph,
            total_dpp: hitungan.amount_dpp,
            total_discount: hitungan.amount_disc,
            deduction: deduksi,
            // grand_total: hitungan.subtotal - deduction - hitungan.amount_pph - hitungan.amount_disc, //salah
            grand_total:
              hitungan.amount_dpp +
              hitungan.amount_ppn -
              deduksi -
              hitungan.amount_pph,
            deduction_remark: res.data.deduction_remark,
          });
        }
      });
    }
  }, [state.order_id]);

  const setChangeOrderType = (e) => {
    setState({ ...state, order_type: e.value });
  };
  const setChangeProv = (e) => {
    getListCity(e.value, 1);
  };

  const getListCity = (e, isEvent) => {
    getProvince(e).then((res) => {
      let _prov = res.data.data.map((item) => {
        return {
          label: item.U_SOL_CITY_NAME,
          value: item.U_SOL_CITY_CODE,
        };
      });
      setState({ ...state, city: _prov[0].value, province: e });
      setInfo({ ...info, province: _prov });
    });
  };
  const onDateDeliveryChange = (event) => {
    setInfo({ ...info, delivery_date: event.target.value });
  };
  const Calculate = (details) => {
    let subtotal = 0;
    let amount_ppn = 0;
    let amount_pph = 0;
    let amount_dpp = 0;
    let amount_disc = 0;
    for (const key in details) {
      let amount = details[key].qty * details[key].price;
      subtotal += amount;
      amount_ppn += parseFloat(details[key].amount_ppn);
      amount_pph += parseFloat(details[key].amount_pph);
      amount_dpp += parseFloat(details[key].amount_dpp);
      amount_disc += parseFloat(details[key].amount_discount);
    }
    return { subtotal, amount_ppn, amount_pph, amount_dpp, amount_disc };
  };

  const hitungTotalDisc = (items) => {
    let total_disk = 0;
    for (const key in items) {
      let _subtotal = items[key].price * items[key].qty;
      let _net_disc = items[key].net_disc > 0 ? items[key].net_disc / 100 : 0;
      let _campaign_disc = parseFloat(items[key].disc_2) / _subtotal;
      let _prcntdisc = _net_disc + (1 - _net_disc) * _campaign_disc;

      total_disk += _prcntdisc * _subtotal;
    }
    return total_disk;
  };
  const onChangePPN = (e, row) => {
    let _total_disc = hitungTotalDisc(detail);
    const index = detail.findIndex((e) => e.id == row.id);
    if (index > -1) {
      detail[index].ppn = e.target.value;

      let subtotal = detail[index].price * detail[index].qty;
      let disc_deduction = parseFloat(
        ((deduction + _total_disc) / info.total) * 100
      );
      let disc_total = subtotal * (parseFloat(disc_deduction) / 100);
      let dpp = parseFloat(
        e.target.value == 0
          ? 0
          : (subtotal - disc_total) / (1 + e.target.value / 100)
      ).toFixed(3);
      let am_ppn = parseFloat(dpp * (e.target.value / 100)).toFixed(2);

      let net_disc = detail[index].net_disc / 100;
      let campaign_disc = subtotal > 0 ? detail[index].disc_2 / subtotal : 0;
      let prcntdisc = net_disc + (1 - net_disc) * campaign_disc;

      detail[index].amount_ppn = am_ppn;
      detail[index].amount_dpp = dpp;
      detail[index].disc_deduction = disc_deduction;
      detail[index].disc_total = disc_total;
      detail[index].amount_pph =
        detail[index].pph == "y" ? dpp * (info.pph_rate / 100) : 0;
      detail[index].amount_discount = prcntdisc * subtotal;
    }
    let payload = {
      VatPrcnt: e.target.value,
    };
    const response = updateSODetail(row.id, payload);
    response.then((res) => {
      const hitungan = Calculate(detail);
      setInfo({
        ...info,
        detail,
        total: hitungan.subtotal,
        total_ppn: hitungan.amount_ppn,
        total_pph: hitungan.amount_pph,
        total_dpp: hitungan.amount_dpp,
        total_discount: hitungan.amount_disc,
        // grand_total: hitungan.subtotal - deduction - hitungan.amount_pph - hitungan.amount_disc
        grand_total:
          hitungan.amount_dpp +
          hitungan.amount_ppn -
          deduction -
          hitungan.amount_pph,
      });
    });
  };
  const onChangePPH = (e, row) => {
    let _total_disc = hitungTotalDisc(detail);
    const index = detail.findIndex((e) => e.id == row.id);
    if (index > -1) {
      let subtotal = detail[index].price * detail[index].qty;
      let disc_deduction = parseFloat(
        ((deduction + _total_disc) / info.total) * 100
      );
      let disc_total = subtotal * (parseFloat(disc_deduction) / 100);
      let dpp = parseFloat(
        detail[index].ppn == 0
          ? 0
          : (subtotal - disc_total) / (1 + detail[index].ppn / 100)
      ).toFixed(3);
      let am_ppn = parseFloat(dpp * (detail[index].ppn / 100)).toFixed(2);

      let net_disc = detail[index].net_disc / 100;
      let campaign_disc = subtotal > 0 ? detail[index].disc_2 / subtotal : 0;
      let prcntdisc = net_disc + (1 - net_disc) * campaign_disc;

      detail[index].pph = e.target.value;
      detail[index].amount_ppn = am_ppn;
      detail[index].amount_dpp = dpp;
      detail[index].disc_deduction = disc_deduction;
      detail[index].disc_total = disc_total;
      detail[index].amount_pph =
        e.target.value == "y" ? dpp * (info.pph_rate / 100) : 0;
      detail[index].amount_discount = prcntdisc * subtotal;
    }

    let payload = {
      WtLiable: e.target.value == "y" ? true : false,
    };
    const response = updateSODetail(row.id, payload);
    response.then((res) => {
      const hitungan = Calculate(detail);
      setInfo({
        ...info,
        detail,
        total: hitungan.subtotal,
        total_ppn: hitungan.amount_ppn,
        total_pph: hitungan.amount_pph,
        total_dpp: hitungan.amount_dpp,
        total_discount: hitungan.amount_disc,
        // grand_total: hitungan.subtotal - deduction - hitungan.amount_pph - hitungan.amount_disc,
        grand_total:
          hitungan.amount_dpp +
          hitungan.amount_ppn -
          deduction -
          hitungan.amount_pph,
      });
    });
  };

  const onChangeDelivery = (e, row) => {
    const index = detail.findIndex((e) => e.id == row.id);
    if (index > -1) {
      detail[index].delivery = e.target.checked;
    }
    let payload = {
      Delivery: e.target.checked,
    };
    const response = updateDelivery(row.id, payload);
    response.then((res) => {
      setInfo({ ...info, detail });
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  const showRejectModal = () => {
    $("#modal-reject").modal();
  };

  const submitReject = () => (event) => {
    event.preventDefault();

    if (validate) {
      const payload = {
        Status: "Reject",
        descstatus: RejectComment.current?.value,
      };

      setState({ ...state, loading: true });
      updateSO(
        state.order_id,
        payload,
        (res) => {
          const { data } = res.data;
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Reject Approval success ",
          }).then((res) => {
            setState({ ...state, refresh: true });
            $("#modal-reject").modal("hide");
          });
        },
        ({ response }) => {
          const { message } = response;
          Swal.fire({
            icon: "error",
            title: "Reject Approval Error",
            text: message,
          });
        }
      ).finally(() => {
        setState({ ...state, loading: false });
      });
    }
  };

  const validate = () => {
    let message = "";
    if (RejectComment.current?.value == "") {
      message = "Comment required!";
    } else {
      return true;
    }
    if (message) {
      Swal.fire({
        title: "Invalid Data",
        text: message,
        icon: "error",
      });
      return false;
    }
  };

  const hideModal = () => {
    $("#modal-reject").modal("hide");
  };

  let total = info.total - total_discount - deduction;
  let total_before_tax =
    userInfo.u_m_pkp == "Y" ? Math.round(total / 1.11) : total;

  const submitSO = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-modena",
        cancelButton: "btn btn-readonly mr-3",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Confirmation",
        text: "Are you sure approve this request ?",
        confirmButtonColor: "#3085d6",
        showCancelButton: true,
        confirmButtonText: "Approve",
        reverseButtons: true,
      })
      .then(({ isConfirmed }) => {
        if (isConfirmed) {
          const { total_pph, grand_total } = info;
          setState({ ...state, loading: true });
          updateSO(
            state.order_id,
            {
              Status: "Approve",
              act: "create",
              hitungan_frontend: {
                DocTotal: total,
              },
            },
            (res) => {
              const { data } = res.data;
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Approve success ",
              }).then(() => {
                setInfo({ ...info, status_so: "Open" });
                getSOHeader(id_so).then((res) => {
                  setState({
                    ...state,
                    approved_date: res.data.approved_date,
                    note_approved: false,
                  });
                });
                //setState({...state, refresh: true});
              });
            },
            ({ response }) => {
              let message = response.message
                ? response.message
                : response.data.message
                  ? response.data.message
                  : "An error while processing your request. Please contact your System Support";
              console.log(response);
              Swal.fire({
                icon: "error",
                title: "Approve Error",
                text: message,
              });
            }
          ).finally(() => {
            setState({ ...state, loading: false });
          });
        }
      });
  };

  const propsPrint = { getState: state, getInfo: info, login: userInfo };

  //useEffect(() => console.log(info), [info]);

  return (
    <div className="content-wrapper">
      <Overlay display={state.loading} />
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <h2 className="title-breadcrum">
                {"Sales Order #" + state.order_no} &nbsp;
                {info.status_so == "Reject" ? (
                  <span className="badge bg-red me-2">Reject</span>
                ) : info.status_so == "Paid" ? (
                  <span className="badge bg-paid me-2">Paid</span>
                ) : info.status_so == "Closed" ? (
                  <span className="badge bg-close me-2">Closed</span>
                ) : info.status_so == "Pending" ? (
                  <span className="badge bg-teal me-2">Pending</span>
                ) : info.status_so == "Open" ? (
                  <span className="badge bg-cyan me-2">Open</span>
                ) : (
                  ""
                )}
                {state.order_id != "" && state.order_id && (
                  <>
                    <div style={{ display: "none" }}>
                      <PrintSO ref={componentRef} {...propsPrint} />
                    </div>
                    <div style={{ float: "right", cursor: "pointer" }}>
                      <img src={print} onClick={handlePrint} />
                    </div>
                  </>
                )}
              </h2>
              <p>Date {moment(info.created_date).format("DD MMMM YYYY")}</p>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3 bg-white">
              <h6 className="m-0 title-breadcrum tx-gray">Info Customer</h6>
            </div>
            <div className="card-body">
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-6">
                  <MInput
                    name="name"
                    label="Name/ID"
                    type="text"
                    icon={<i className="bi bi-people"></i>}
                    readOnly
                    defaultValue={info.nama_customer}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <div className="mb-3">
                    <MInput
                      id="delivery_date"
                      name="delivery_date"
                      label="Delivery Date"
                      type="date"
                      disabled={true}
                      value={info.delivery_date}
                      icon={<i className="bi bi-calendar3"></i>}
                      onChange={onDateDeliveryChange}
                      required
                    />
                  </div>
                </div>
                {/* <div className='col-sm-3'>
                                    <div className="mb-3">
                                        <MSelect label='Order Type' options={info.ordertype} value={state.order_type} onChange={setChangeOrderType} disabled={true} />
                                    </div>
                                </div> */}
              </div>
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-6">
                  <MInput
                    name="phone"
                    label="Phone Number"
                    type="text"
                    icon={<i className="bi bi-phone"></i>}
                    readOnly
                    defaultValue={info.phone}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <div className="mb-3">
                    <MInput
                      name="email"
                      label="Email"
                      type="email"
                      icon={<i className="bi bi-envelope"></i>}
                      readOnly
                      defaultValue={info.email}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-12">
                  <div className="mb-3">
                    <MTextarea
                      label="Address"
                      name="Address"
                      icon={<i className="bi bi-geo-alt"></i>}
                      rows={3}
                      readOnly
                      value={info.address}
                    />
                  </div>
                </div>
              </div>
              <div className="row" style={{ padding: "10px 65px" }}>
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MSelect
                      label="Country"
                      options={options}
                      value={state.county}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MSelect
                      label="Province"
                      options={info.country}
                      value={state.province}
                      onChange={setChangeProv}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="mb-3">
                    <MSelect
                      label="City"
                      options={info.province}
                      value={state.city}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {info.detail && info.detail.length > 0 && (
            <>
              <div className="card shadow mb-4">
                <div className="card-header py-3 bg-white">
                  <div className="row">
                    <div className="col-sm-8">
                      <h6 className="m-0 title-breadcrum tx-gray">
                        Detail Product
                      </h6>
                    </div>
                    <div className="col-sm-4 text-right">
                      D : Display R : Ready I : Indent
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-hover"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th className="th-no-border">No</th>
                          <th className="th-no-border">Product</th>
                          <th className="th-no-border">Qty</th>
                          <th className="th-no-border"></th>
                          <th className="th-no-border">Currency</th>
                          <th className="th-no-border">Price / Unit</th>
                          <th className="th-no-border">Net / Disc</th>
                          <th className="th-no-border">PPN</th>
                          <th className="th-no-border">PPH</th>
                          <th className="th-no-border">Gross Total</th>
                          <th className="th-no-border">Order Type</th>
                          <th className="th-no-border"></th>
                          <th className="th-no-border">Delivery</th>
                        </tr>
                      </thead>

                      <tbody>
                        {detail.map((row, index) => (
                          <>
                            <tr key={`tr-` + index}>
                              <td>{index + 1}</td>
                              <td>
                                <label
                                  style={{
                                    textAlign: "center",
                                    display: "block",
                                  }}
                                >
                                  {row.itemname} ({row.itemno})
                                </label>
                              </td>
                              <td width={60}>
                                <label
                                  style={{
                                    textAlign: "center",
                                    display: "block",
                                  }}
                                >
                                  {row.qty}
                                </label>
                              </td>
                              <td width={20}>
                                <label>{row.type}</label>
                              </td>
                              <td width={50}>
                                <label>IDR</label>
                              </td>
                              <td width={150} style={{ textAlign: "right" }}>
                                <label> {NumberFormat(row.price)}</label>
                              </td>
                              <td width={80}>
                                <label>{row.net_disc}%</label>
                              </td>
                              <td width={180}>
                                <select
                                  name="ppn"
                                  className="form-control ps-0"
                                  onChange={(e) => onChangePPN(e, row)}
                                  value={row.ppn}
                                  disabled={true}
                                >
                                  {listppn.map((_ppn, i) => (
                                    <option
                                      key={`ppn-` + i}
                                      value={parseFloat(_ppn.Rate)}
                                    >
                                      {NumberFormat(_ppn.Rate)}%
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td width={150}>
                                <select
                                  name="pph"
                                  className="form-control ps-0"
                                  onChange={(e) => onChangePPH(e, row)}
                                  value={row.pph}
                                  disabled={true}
                                >
                                  <option value="y">Yes</option>
                                  <option value="n">No</option>
                                </select>
                              </td>
                              <td
                                style={{ paddingRight: 0, textAlign: "right" }}
                              >
                                {NumberFormat(row.net_disc_amt)}
                              </td>
                              <td width={140}>
                                <select
                                  name="order_type"
                                  className="form-control ps-0"
                                  style={{ width: 140 }}
                                  value={row.M_TP_PENJ}
                                  disabled={true}
                                >
                                  {info.ordertype
                                    .filter((rows) => {
                                      if (
                                        row.type === "R" ||
                                        row.type === "D"
                                      ) {
                                        return rows.value == "FGS";
                                      } else {
                                        return rows.value;
                                      }
                                    })
                                    .map((_type, i) => (
                                      <option
                                        key={`type-` + i}
                                        value={_type.value}
                                      >
                                        {_type.label}
                                      </option>
                                    ))}
                                </select>
                              </td>
                              <td></td>
                              <td>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultChecked={row.delivery}
                                    onChange={(e) => onChangeDelivery(e, row)}
                                    disabled={true}
                                  />
                                </div>
                              </td>
                            </tr>
                            {row.paketid && row.free == 0 && (
                              <>
                                <tr key={`tr-` + index}>
                                  <td colSpan={7}></td>
                                  <td
                                    colSpan={2}
                                    style={{ fontSize: 14, padding: 0 }}
                                  >
                                    {row.paket_name}
                                  </td>
                                  <td
                                    style={{ padding: 0, textAlign: "right" }}
                                  >
                                    -{NumberFormat(Math.round(row.disc_2))}
                                  </td>
                                  <td colSpan={2}></td>
                                </tr>
                                <tr>
                                  <td colSpan={7}></td>
                                  <td
                                    colSpan={2}
                                    style={{
                                      fontSize: 14,
                                      padding: 0,
                                      fontWeight: 500,
                                    }}
                                  >
                                    Final Price
                                  </td>
                                  <td
                                    style={{ padding: 0, textAlign: "right" }}
                                  >
                                    {NumberFormat(
                                      Math.round(
                                        row.price * row.qty -
                                        row.amount_discount
                                      )
                                    )}
                                  </td>
                                  <td colSpan={2}></td>
                                </tr>
                              </>
                            )}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="row" style={{ marginBottom: 50 }}>
                    <div className="col-sm-7">
                      <div className="note">
                        Dokumen ini bukan merupakan bukti transaksi, silakan
                        melakukan pembayaran terlebih dahulu. Pembayaran yang
                        dilakukan melalui sistem kami akan dianggap sah apabila
                        memenuhi syarat-syarat berikut:
                        <ul>
                          <li style={{ marginTop: "10px" }}>
                            <b>Kartu Kredit atau Kartu Debit:</b>
                          </li>
                          Transaksi menggunakan Kartu Kredit atau Kartu Debit
                          dianggap sah jika mengunakan mesin EDC yang tersedia
                          pada MHC Store.
                          <li style={{ marginTop: "10px" }}>
                            <b>Payment Transfer Bank: </b>
                          </li>
                          Pembayaran menggunakan Payment Gateway(Xendit). yang
                          akan mengirimkan link payment melalu WA/Email yang
                          bisa anda transfer dan akan di verifikasi oleh payment
                          gateway. Customer akan menerima email berupa INOVICE
                          sebagai bukti transaksi setelah pembayaran
                          terverifikasi oleh system
                        </ul>
                      </div>
                      <div className="note" style={{ marginBottom: 10 }}>
                        <div style={{ display: "block" }}>
                          Remark: {info.deduction_remark}
                        </div>
                        <span> </span>
                      </div>
                      {!state.note_approval && state.approved_date && (
                        <div style={{ padding: 10, background: "#ffeecf" }}>
                          <div
                            style={{
                              marginBottom: 0,
                              marginTop: 5,
                              fontWeight: "bold",
                              fontSize: 18,
                            }}
                          >
                            Informasi Approval :{" "}
                          </div>
                          <h4
                            style={{
                              fontStyle: "italic",
                              fontSize: 21,
                              color: "rgb(255, 168, 0)",
                              fontWeight: 500,
                            }}
                          >
                            - Sudah di approve pada tanggal{" "}
                            {moment(state.approved_date).format(
                              "DD MMM YYYY HH:mm:ss"
                            )}
                          </h4>
                        </div>
                      )}
                      {info.status_so == "Reject" && (
                        <div style={{ padding: 10, background: "#f71a1a21" }}>
                          <div
                            style={{
                              marginBottom: 0,
                              marginTop: 5,
                              fontWeight: "bold",
                              fontSize: 18,
                            }}
                          >
                            Informasi Reject :{" "}
                          </div>
                          <h4
                            style={{
                              fontStyle: "italic",
                              fontSize: 21,
                              color: "red",
                              fontWeight: 500,
                            }}
                          >
                            - Sudah di reject pada tanggal{" "}
                            {moment(state.approved_date).format(
                              "DD MMM YYYY HH:mm:ss"
                            )}
                            <br />- Catatan : {state.note_approval}
                          </h4>
                        </div>
                      )}
                    </div>
                    <div className="col-sm-5">
                      <h2 className="title-promo">Detail Price</h2>
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          Total Before Discount
                        </div>
                        <div className="col-sm-6 text-right">
                          {NumberFormat(info.total)}
                        </div>
                        <div
                          className="col-sm-6 mb-2"
                          style={{ color: "#BE4A31" }}
                        >
                          Campaign Discount
                        </div>
                        <div
                          className="col-sm-6 text-right"
                          style={{ color: "#BE4A31" }}
                        >
                          -{" "}
                          {NumberFormat(
                            info.total_before_discount_with_free -
                            Math.round(total) -
                            deduction
                          )}
                        </div>
                        {deduction > 0 && (
                          <>
                            <div
                              className="col-sm-6 mb-2"
                              style={{
                                color: "#fff",
                                background: "#FFA800",
                                paddingTop: 5,
                                paddingBottom: 5,
                                fontWeight: "bold",
                              }}
                            >
                              Additional Discount
                            </div>
                            <div
                              className="col-sm-6 mb-2 text-right"
                              style={{
                                color: "#fff",
                                background: "#FFA800",
                                paddingTop: 5,
                                paddingBottom: 5,
                                fontWeight: "bold",
                              }}
                            >
                              -{" "}
                              {NumberFormat(
                                Math.round(ParseDecimal(deduction))
                              )}
                            </div>
                          </>
                        )}

                        <div className="col-sm-6 mb-2">Total</div>
                        <div className="col-sm-6 text-right">
                          {NumberFormat(Math.round(total))}
                        </div>
                        <div className="col-sm-6 mb-2">Total Before Tax</div>
                        <div className="col-sm-6 text-right">
                          {NumberFormat(total_before_tax)}
                        </div>
                        <div className="col-sm-6 mb-2">Tax</div>
                        <div className="col-sm-6 text-right">
                          {NumberFormat(Math.round(total - total_before_tax))}
                        </div>
                        {/* <div className='col-sm-6 mb-2'>NON PPN</div>
                                                <div className='col-sm-6 text-right'>{NumberFormat(Math.round( ParseDecimal(Math.abs(info.grand_total - info.total_dpp - info.total_ppn + info.total_pph))))}</div>*/}
                        <div className="col-sm-6 mb-2">
                          Witholding Tax{" "}
                          {info.pph_rate > 0 && "(" + info.pph_rate + "%)"}
                        </div>
                        <div className="col-sm-6 text-right">
                          (
                          {NumberFormat(
                            Math.round(ParseDecimal(info.total_pph))
                          )}
                          )
                        </div>

                        <div className="col-sm-6 grand-total">Grand Total</div>
                        <div className="col-sm-6 text-right grand-total">
                          {NumberFormat(Math.round(ParseDecimal(total)))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {info.status_so == "Pending" && (
                <div className="row" style={{ justifyContent: "flex-end" }}>
                  <div className="col-sm-2">
                    <button
                      className="btn btn-outline-danger btn-block"
                      style={{ marginBottom: 30 }}
                      type="button"
                      onClick={showRejectModal}
                    >
                      Reject
                    </button>
                  </div>
                  <div className="col-sm-2">
                    <button
                      className="btn btn-modena btn-block"
                      style={{ marginBottom: 30 }}
                      type="button"
                      onClick={submitSO}
                    >
                      Approve
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </section>
      <div id="modal-reject" className="modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <form onSubmit={submitReject()}>
                <div className="row">
                  <h4
                    style={{
                      display: "block",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Confirmation
                  </h4>
                  <p className="text-center" style={{ width: "100%" }}>
                    Are you sure reject this Additional Discount ?
                  </p>
                </div>
                <div className="row" style={{ padding: "10px 15px" }}>
                  <div className="col-sm-12">
                    <label>Note</label>
                    <div className="input-group input-group-joined">
                      <textarea
                        maxLength={100}
                        required={true}
                        className="form-control"
                        rows={3}
                        ref={RejectComment}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="row" style={{ padding: "10px 15px" }}>
                  <div className="col-sm-6">
                    <button
                      className="btn btn-readonly btn-block"
                      style={{ marginBottom: 30 }}
                      type="button"
                      onClick={hideModal}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-sm-6">
                    <button
                      className="btn btn-modena btn-block"
                      style={{ marginBottom: 30 }}
                      type="submit"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalSOForm;
